import { useEffect, forwardRef } from 'react';
import TextField from '@mui/material/TextField';
import loadable from '@loadable/component';
import ready from 'document-ready';
import intlTelInput from 'intl-tel-input';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const intlTelInputUtils = loadable(() => import('intl-tel-input/build/js/utils.js'));
const intlTelStyle = loadable(() => import('intl-tel-input/build/css/intlTelInput.css'));

const PhoneField = forwardRef((props, ref) => {

    const {
        id,
        name,
        size,
        value,
        label,
        error,
        onChange,
        fullWidth,
        helperText,
        intlTelInput: init,
        sx: inputStyles,
        inputProps: inputAttributes,
        InputProps,
        disabled
    } = props;

    const sx = {
        height: '100%',
        '& .MuiFormLabel-root': {
            marginLeft: '42px'
        },
        '& .MuiInputBase-root': {
            height: '100%'
        },
        ...inputStyles
    };

    const sitePhoneFormatCultureCode = useRecoilValue(atoms.sitePhoneFormatCultureCode);

    const inputProps = {
        style: {
            height: '100%'
        },
        ...inputAttributes
    };

    useEffect(() => {
        ready(() => {
            const phoneElement = document.getElementById(id);
            if (phoneElement) {
                intlTelStyle.load().then(() => { });
                intlTelInputUtils.load().then(() => {
                    init(intlTelInput(phoneElement, {
                        nationalMode: true,
                        formatOnDisplay: false,
                        autoHideDialCode: false,
                        autoPlaceholder: 'off',
                        preferredCountries: ['us', 'gb', 'ca'],
                        initialCountry: sitePhoneFormatCultureCode ? sitePhoneFormatCultureCode.substring(sitePhoneFormatCultureCode.length - 2) : 'us'
                    }));
                });
            }
        });
    }, []);

    return (
        <TextField
            id={id}
            name={name}
            size={size}
            value={value}
            label={label}
            error={error}
            onChange={onChange}
            fullWidth={fullWidth}
            helperText={helperText}
            inputRef={ref}
            inputProps={inputProps}
            sx={sx}
            InputProps={InputProps}
            disabled={disabled}
        />
    );
});

export default PhoneField;